import React from 'react'
import HeroImage from "../../assets/privacyBanner.jpg";

function HeroPrivacyPolicy() {
  return (
    <div>
      <div className="HeroPrivacyPolicy">
        <main className="max-w-7xl mx-auto px-4 py-16 md:py-20">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Left Column */}
            <div>
              <h1 className="text-4xl md:text-5xl font-bold mb-6">
                Your Privacy Matters to  <br />
                <div className="italic font-bold text-blue-600">Us.</div>
              </h1>
              <p className="text-gray-600 mb-5 max-w-lg">
                At Pay363, we are committed to protecting your personal data and ensuring your privacy every step of the way. Our Privacy Policy outlines how we collect, use, and safeguard your information when you use our services.
                We believe in transparency, security, and putting you in control of your data.
              </p>
              <p className="text-gray-600 mb-8 max-w-lg">
                🔒 100% Secure | 📃 Fully Transparent | ✅ PCI -DSS Compliance
              </p>

              {/* <div className="space-y-6">
                <div className="">
                  <button className="bg-blue-600 text-sm text-white px-10 py-3 rounded-lg">
                    Create account
                  </button>
                </div>

              </div> */}
            </div>

            {/* Right Column */}
            <div className="space-y-4">
              <div className="bg-gray-100 rounded-3xl">
                <img
                  src={HeroImage}
                  alt="Credit cards"
                  className="w-full h-auto rounded-2xl"
                />
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  )
}

export default HeroPrivacyPolicy